import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { apiService } from "../../constants/ApiService";
import { LEAD_STATUS_COLORS } from "../../constants/DateFormatter";
import { toast } from 'react-toastify';
import useVendorBranch from '../../utils/useVendorBranch';
import conditionalDataLoad from '../../utils/conditionalDataLoad';
import { useSelector } from 'react-redux';
import VendorBranchSelector from '../../components/VendorBranchSelector';

const LeadsPendingForEnrollment = () => {
  const [errorMessage, setErrorMessage] = useState({});
  const { user } = useSelector((state) => state.authState);
  const {
    isSuperAdmin,
    isAdmin,
  hasMultiBranch,
        hasSingleBranch} = useVendorBranch(user);
  const [selectionData, setSelectionData] = useState({
    vendor_id: "",
    branch_id: "",
  });
  const getToday = () => {
  return new Date().toISOString().split("T")[0];
};
  const navigate = useNavigate();
  const [leadData, setLeadData] = useState([]);
  const [statuses, setStatuses] = useState([]);
  const [activeStatus, setActiveStatus] = useState("EnrollmentPending");
  const [searchTerm, setSearchTerm] = useState("");
  const [fromDate, setFromDate] = useState(getToday());
  const [toDate, setToDate] = useState(getToday());

  // ✅ Fetch leads with filters
  const GetLead_Creation_MasterData = async (
    leadStatus = "EnrollmentPending",
    search = searchTerm,
    fromdate = fromDate,
    todate = toDate
  ) => {
    try {
      const vendorId = selectionData.vendor_id || "";
      const branchId = selectionData.branch_id || "";

      const config = {
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        params: {
          search: search || "",
          fromdate: fromdate || null,
          todate: todate || null,
          leadStatus: leadStatus === "All" ? "" : leadStatus,
          // user_id: 0,
          // user_prof: "Admin",
        },
      };

      const response = await apiService.get(
        `api/Lead_Master_Import/GetLead_Master_Import?vendorId=${vendorId}&branchId=${branchId}&`,
        config
      );

      if (response.status === true && Array.isArray(response.data)) {

        setLeadData(response.data);
      } else {
        setLeadData([]);
      }
    } catch (error) {
      console.error(error);
      alert("Something went wrong while fetching leads");
    }
  };

  // ✅ Fetch Lead Statuses
  const GetLeadStatuses = async () => {
    try {
      const response = await apiService.get(
        `api/Multi_Purpose_Type_Master/GetMulti_Purpose_Type_Master?filter=lead_status&orderBy=id`
      );

      if (response.status === true && Array.isArray(response.data)) {
        setStatuses(response.data);
      } else {
        setStatuses([]);
      }
    } catch (error) {
      console.error(error);
      alert("Error fetching lead statuses");
    }
  };

  // ✅ Initial load
  useEffect(() => {
    GetLeadStatuses();
    //  GetLead_Creation_MasterData();
  }, []);

  // ✅ Re-fetch when filters change
  // useEffect(() => {
  //   const delayDebounce = setTimeout(() => {
  //     GetLead_Creation_MasterData();
  //   }, 400);

  //   return () => clearTimeout(delayDebounce);
  // }, [activeStatus, searchTerm, fromDate, toDate]);


  useEffect(() => {
    const canLoad = conditionalDataLoad({
        hasMultiBranch,
        hasSingleBranch,
      isSuperAdmin,
      isAdmin,
      vendorId: selectionData.vendor_id,
      branchId: selectionData.branch_id,
    });
    if (canLoad) {
      GetLead_Creation_MasterData();
    }
  }, [activeStatus, searchTerm, fromDate, toDate, selectionData.vendor_id, selectionData.branch_id]);

  const handleClick = (id) => {
    navigate("/enrollment-form", );
    // navigate("/lead-history/" + id);
  };

  const renderTableRows = (data) =>
    data.map((lead, index) => (
      <tr key={index}>
        <td>{lead.id}</td>
        <td>
          <button className="btn btn-primary btn-sm">
            Enroll Now <i
            className="bi bi-arrow-right"
            style={{ cursor: "pointer" }}
            onClick={() => handleClick(lead.id)}
          />
          </button>
          
        </td>
        <td><span
          className={`badge rounded-pill px-3 py-2 ms-2 ${LEAD_STATUS_COLORS[lead.lead_status] || "bg-light text-dark"
            }`}
        >{lead.lead_status}</span></td>
        <td>{lead.cust_name}</td>
        <td>{lead.cust_email}</td>
        <td>{lead.cust_mobile}</td>

        {/* <td>{lead.status}</td> */}
      </tr>
    ));

  return (
    <>
      <div className='text-right mb-3'>
        <Link
          to="/all-leads"
          className="btn btn-warning btn-sm rounded-pill shadow-sm px-3"
        >
          <i className="bi bi-arrow-left mr-1"></i>
          Back
        </Link>
      </div>


      <VendorBranchSelector user={user} selectionData={selectionData} setSelectionData={setSelectionData} errorMessage={errorMessage} accessButton={true} />
      <div className="card border-0 shadow-sm rounded-4">
        <div className="card-body">
          {/* Header */}
          <div className="d-flex flex-column flex-md-row justify-content-between align-items-md-center mb-4 gap-3">

            {/* Title */}
            <div>
              <h4 className="fw-bold text-primary mb-1">
                <i className="bi bi-clock mr-2"></i> Pending for Enrollment
              </h4>
              <small className="text-muted">
                Showing <span className="fw-semibold">{leadData.length}</span> records
              </small>
            </div>

            {/* Search */}
            <div className="position-relative w-50 w-md-50">


              <input
                type="search"
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                className="form-control ps-5 rounded-pill"
                placeholder="Search ..."
              />
            </div>
          </div>

          {/* Filters */}
          <div className="row g-3 mb-4">

            {/* Filter Label */}
            {/* <div className="col-12 col-md-4">
              <label className="fw-semibold text-secondary mb-1">
                <i className="bi bi-funnel mr-1"></i> Filter by Status
              </label>
              <select
                className="custom-select"
                value={activeStatus}
                onChange={(e) => setActiveStatus(e.target.value)}
              >
                <option value="All">All</option>
                {statuses.map((status) => (
                  <option key={status.id} value={status.multi_purpose_type}>
                    {status.multi_purpose_type}
                  </option>
                ))}
              </select>
            </div> */}

            {/* From Date */}
            <div className="col-6 col-sm-6 col-md-4">
              <label className="fw-semibold text-secondary mb-1"><i className="bi bi-funnel mr-1"></i> Filter From Date</label>
              <input
                type="date"
                className="form-control"
                value={fromDate}
                onChange={(e) => setFromDate(e.target.value)}
              />
            </div>

            {/* To Date */}
            <div className="col-6 col-sm-6 col-md-4">
              <label className="fw-semibold text-secondary mb-1">To Date</label>
              <input
                type="date"
                className="form-control"
                value={toDate}
                onChange={(e) => setToDate(e.target.value)}
              />
            </div>

          </div>



          {/* Table */}
          <div className="bg-opacity-10 px-3 py-2 border-bottom rounded-top">
            <h6 className="text-primary fw-bold mb-0 text-center">
              Students Pending for Enrollment 
            </h6>
          </div>
          <div className="table-responsive border rounded-4 shadow-sm">

            <table className="table table-hover align-middle mb-0">
              <thead className="table-light">
                <tr>
                  <th>#</th>
                  <th>Action</th>
                  <th>Status</th>
                  <th>Name</th>
                  <th>Email</th>
                  <th>Phone</th>
                  {/* <th>Status</th> */}
                </tr>
              </thead>
              <tbody>
                {leadData.length > 0 ? (
                  renderTableRows(leadData)
                ) : (
                  <tr>
                    <td colSpan="9" className="text-center py-4 text-muted">
                      <i className="bi bi-inbox mr-2"></i>No Records found.
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </>
  );
};

export default LeadsPendingForEnrollment;
